/* eslint-disable max-len */

import React from 'react';
import {Header} from 'semantic-ui-react';
import LocationFull from '../icons/location';
import LocationEmpty from '../icons/locationEmpty';
import './styles.scss';

const Point = ({description, index, last, indexCurrent}) => {
  return (
    <div className='timeline-customer-item-container'>
      <div className="timeline-customer-point-container timeline-customer-location">
        {indexCurrent === -1 ?
          <LocationFull color={'#414752'} /> :
          (indexCurrent >= index ? <LocationFull color={'#EB0A1E'}/> : <LocationEmpty color={'#414752'} />)}
      </div>
      <div className="timeline-customer-point-container">
        <hr className={`timeline-customer-line
          ${index === 0 ? 'timeline-line-transparent' : indexCurrent === -1 || indexCurrent === index ? 'timeline-line-red' : 'timeline-line-grey'}
          `} />
        <div className={`timeline-customer-circle
          ${indexCurrent === index ? 'timeline-selected' : 'timeline-empty'}
          ${indexCurrent === -1 ? 'timeline-border-red' : 'timeline-border-grey'}
          `}>
        </div>
        <hr className={`timeline-customer-line
          ${index === last ? 'timeline-line-transparent' : indexCurrent === -1 ? 'timeline-line-red' : 'timeline-line-grey'}
          `} />
      </div>
      <div className="timeline-customer-text-container">
        <Header className='title-custom-timeline-customer' size='small' textAlign='center'>{description}</Header>
      </div>
    </div>
  );
};

const TimeLine = ({timeLineData}) => {
  let indexCurrent = -1;
  return (
    <div className="timeline-customer-container">
      {timeLineData?.map((item, index) => {
        if (item.status) {
          indexCurrent = index;
        }
        return (
          <>
            <Point
              description={item.trackingDescription}
              index={index}
              indexCurrent={indexCurrent}
              last = {timeLineData.length - 1}
            />
          </>
        );
      }
      )}
    </div>
  );
};

export default TimeLine;
